import { Box, Typography } from "@mui/material";
import { Badge, Button, Color, Tooltip } from "@axismaxlife/unified-ui-components-library";
import { InfoIcon } from "@axismaxlife/unified-ui-components-library/dist/systemIcons";
import { String } from "../constants/Strings";
import { colors } from "../style/color/colors";
import { fonts } from "../style/fonts/fonts";
import { DetailSummaryCard } from "./DetailSummaryCard";

export const FinancialCollectionRow = ({
  title,
  count,
  tooltip,
  total,
  totalLabel = String.Dashboard.snapshot.totalLabel,
  addLabel,
  onAdd,
  entries = [],
  showInlineEntries = false,
  onEdit,
  onDelete,
}) => (
  <Box sx={{ mt: "20px" }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: fonts.manrope,
            fontWeight: 700,
            color: colors.NeutralDark700,
          }}
        >
          {title}
        </Typography>
        {count !== undefined && (
          <Badge state="information" style="bordered" size="small">
            {count ?? 0}
          </Badge>
        )}
      </Box>
      <Tooltip
        device="mobile"
        mode="information"
        trigger="click"
        placement="bottom-end"
        showTitle
        title={tooltip.title}
        bodyText={tooltip.body}
        showCloseButton
      >
        <Box
          component="span"
          sx={{ display: "flex", cursor: "pointer", flexShrink: 0 }}
        >
          <InfoIcon size="default" fillColor={Color.Icons.Default} />
        </Box>
      </Tooltip>
    </Box>

    {showInlineEntries &&
      entries.map((entry, index) => (
        <DetailSummaryCard
          key={index}
          title={entry.title}
          subtitle={entry.subtitle}
          rows={entry.rows}
          onEdit={() => onEdit && onEdit(index)}
          onDelete={() => onDelete && onDelete(index)}
        />
      ))}

    <Box
      sx={{
        mt: "8px",
        px: "16px",
        py: "10px",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        backgroundColor: colors.NeutralLightN60,
        cursor: "pointer",
        "& .glide-button": {
          padding: "0 !important",
          minHeight: "auto !important",
        },
      }}
      onClick={onAdd}
    >
      <Box>
        <Typography
          sx={{
            fontSize: "13px",
            fontFamily: fonts.notoSans,
            color: colors.NeutralDark600,
            fontWeight: 400,
          }}
        >
          {totalLabel}
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: fonts.notoSans,
            fontWeight: 400,
            color: colors.NeutralDark600,
          }}
        >
          {total}
        </Typography>
      </Box>
      <Button
        buttonType="neutralLink"
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          onAdd();
        }}
      >
        {addLabel}
      </Button>
    </Box>
  </Box>
);
